import { getErpBranchDetails, getErpTenantName } from "../erpClient";
import { getSessionBranchId } from "./sessionBranch";

/**
 * Resolve tenant_name from localStorage `branch_details` (session branch first),
 * then the standalone `tenant_name` key set at login.
 * API supplies title-style names (e.g. "Manglik Gold").
 */
export function getTenantName() {
  try {
    const branches = getErpBranchDetails();
    const sessionBranchId = getSessionBranchId();

    if (sessionBranchId != null) {
      const match = branches.find(
        (b) => Number(b?.id) === Number(sessionBranchId),
      );
      const fromSession = match?.tenant_name;
      if (fromSession != null && String(fromSession).trim() !== "") {
        return String(fromSession).trim();
      }
    }

    for (const branch of branches) {
      const name = branch?.tenant_name;
      if (name != null && String(name).trim() !== "") {
        return String(name).trim();
      }
    }

    return String(getErpTenantName() || "").trim();
  } catch {
    return "";
  }
}

/** Title case as stored (for UI / alts / silver barcodes). */
export function getTenantNameDisplay() {
  return getTenantName();
}

/** Uppercase for PDF company headers / signatures (was MANGLIK GOLD). */
export function getTenantNameUpper() {
  return getTenantName().toUpperCase();
}
